import Api from '@api/team'
import { message } from 'hljd'

class Store {
  constructor(homeStore) {
    this.homeStore = homeStore
  }

  realPhotoEdit = async () => {
    const { success } = await Api.realPhotoEdit({
      real_photos: this.homeStore.real_photos
    })

    if (success) {
      message.success('操作成功')
      this.homeStore.getRealPhotos()
    }
  }

  uploadOk = (link, info) => {
    this.homeStore.real_photos = this.homeStore.real_photos.concat({
      cover_path: link,
      height: info.height,
      width: info.width
    })
  }

  sortImg = list => {
    this.homeStore.real_photos = list
  }

  onCliped = ({ index, clipUrl }) => {
    const photo = this.homeStore.real_photos.find((item, i) => index === i)

    if (photo) {
      photo.cover_path = clipUrl
    }
  }

  removeImg = index => {
    this.homeStore.real_photos = this.homeStore.real_photos.filter(
      (item, i) => index !== i
    )
  }
}

export default Store
